import { useMutation } from "@tanstack/react-query";
import Cookies from "universal-cookie";
import { TOKEN_NAME, COMPANY_ID, PRODUCT_SLUG } from "../config";
import axios from "../api/axios";

const cookies = new Cookies();

const useExcelUpload = ({
  url = "excelUploadAttendance",
  onSuccess,
  onError,
  paramName = "excel_file",
}) => {
  const upload = useMutation({
    mutationFn: (file) => handleExcelUpload(file),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (err) => {
      onError?.(err);
    },
  });

  const handleExcelUpload = async (file) => {
    // Validate file extension
    const validExtensions = [".xlsx", ".xls"];
    const fileExtension = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();

    if (!validExtensions.includes(fileExtension)) {
      throw new Error("Please upload a valid Excel file (.xlsx or .xls)");
    }

    let token = cookies.get(TOKEN_NAME);
    let fd = new FormData();
    fd.append("company_id", cookies.get(COMPANY_ID));
    fd.append("product_slug", PRODUCT_SLUG);
    fd.append(paramName, file);

    const response = await axios({
      method: "POST",
      url: `/${url}`,
      data: fd,
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    });

    return response;
  };

  return {
    upload,
    isLoading: upload.isLoading,
  };
};

export default useExcelUpload;
